export type PairStatus = 'quick_pair' | 'full_pair' | 'not_paired'
export const PairStatuses = {
	not_paired: 0,
	quick_pair: 1,
	full_pair: 2,
} as const satisfies Record<PairStatus, number>

// The type type of pairing required for a particular feature
export type PairRequired = Extract<PairStatus, 'quick_pair' | 'full_pair'>

// For some number of devices, the result of checking `PairRequired`.
export type PairRequiredStatus =
	| 'full_pair_required'
	| 'no_devices'
	| 'paired'
	| 'some_devices_paired'
